export const Permissions = {
    SalesView: "sales-view",
    SalesCreate: "sales-create",
    SalesEdit: "sales-edit",
    SalesInvoince: "sales-invoince",
    SalesRefund: "sales-refund",
    SalesVoid: "sales-void",
    SalesPayment: "sales-payment",
    SalesPrint: "sales-print",
    SalesUpdateCustomer: "sales-update-customer",
    CustomerView: "customer-view",
    CustomerCreate: "customer-create",
    CustomerEdit: "customer-edit",
    StockView: "stock-view",
    StockMovementsHistoryView: 'stock-movements-history-view',
    StockExport: "stock-export",
    StockControl: "stock-control",
    StockPrint: "stock-print",
    StockCreate: "stock-create",
    StockAuditor: "stock-auditor",
    CashregisterView: "cashRegister-view",
    CashregisterCreate: "cashRegister-create",
    AuditorView: "auditor-view",
    AuditorCreate: "auditor-create",
    AuditorEdit: "auditor-edit",
    ComprobanteInter: "comprob-inter",
    AjusteCaja: "ajuste-caja",
    SettlementsView: 'terminal-settlements-view',
    SettlementsCreate: 'terminal-settlements-create'
}

export const PermissionsSalesAuthorized = [
    Permissions.SalesInvoince,
    Permissions.SalesRefund,
    Permissions.SalesVoid,
    Permissions.SalesPayment,
    Permissions.SalesPrint
];